import { Button } from "components/atoms";
import { ProgressBar } from "components/molecules";
import { useOnBoardingGs1 } from "partner/_hooks";

const Forbidden = () => {
  const { lookAndFeel } = useOnBoardingGs1();

  return (
    <div className="h-full flex flex-col justify-center text-center gap-5">
      {lookAndFeel?.logo &&
        <img src={lookAndFeel?.logo?.src} alt="nbsk-logo" className="w-[90%] max-h-[100px] max-w-[500px] mx-auto mb-1"/>
      }
      
      <div className="max-w-[100%]">
        <ProgressBar max={1} progress={1} color={lookAndFeel?.progressbar} />
      </div>

      <p className="text-2xl">Usuario no autorizado</p>
      <p>Contrata tu membresía de catálogo electrónico para acceder a Syncfonía imágenes</p>

      <Button
        className="text-white rounded-lg"
        style={{
          backgroundColor: lookAndFeel?.primary?.solid
        }}
        fullwidth
        pulse
        onClick={() => window.location.replace(lookAndFeel?.requestAccess)}
      >
        Iniciar mi solicitud
      </Button>
    </div>
  );
};

export default Forbidden;
